import { v4 as uuidv4 } from 'uuid';
import { FieldType } from './fieldType';
import { CultureTextModel } from './form';

export interface BaseFieldModel {
  id: string;
  size: number;
  text: CultureTextModel[] | string;
  hiddenText: boolean;
  textColor: string | undefined;
  enabled: boolean;
  visible: boolean;
  required: boolean;
  excludeFromReport: boolean;
}
export class BaseField implements BaseFieldModel {
  public id: string;
  public size = 6;
  public text: CultureTextModel[] | string;
  public hiddenText = false;
  public textColor: string | undefined;
  public enabled = true;
  public visible = true;
  public required = false;
  public excludeFromReport = false;

  constructor(type: FieldType, cultures: string[] | null = null) {
    this.id = uuidv4();

    if (cultures) {
      this.text = [];
      for (const culture of cultures) {
        this.text.push({ culture, value: type });
      }
    } else {
      this.text = type;
    }
  }
}
